import React from 'react';
import classNames from 'classnames';
import styles from './radio-button.module.css.js';

const RadioButton = ({ disabled, id, isChecked = false, name, value, onChange, size = 'medium', }) => {
    return (React.createElement("span", { className: classNames('bc-radio-button', styles.radioButton) },
        React.createElement("input", { checked: isChecked, className: styles.nativeRadioButton, "data-testid": 'native-radio-button', disabled: disabled, id: id, name: name, onChange: onChange, type: 'radio', value: value }),
        React.createElement("span", { "data-testid": 'radio-button', className: classNames(styles.radioButtonIcon, {
                [styles.small]: size === 'small',
                [styles.large]: size === 'large',
            }) })));
};

export { RadioButton };
